import React from 'react';

const MenuBurgerIcon = ({className}) => (
  <svg className={className} viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5">
      <rect width="20" height="1.625" />
      <rect y="5.6875" width="20" height="1.625" />
      <rect y="11.375" width="20" height="1.625" />
    </g>
  </svg>

);

export default MenuBurgerIcon;
